var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pro-loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.company.itemScriptLoading),expression:"company.itemScriptLoading"}]}),_vm._v(" "),_c('div',{ref:"scriptWrapper",staticClass:"module-content"},[_c(_vm.module,{tag:"component",attrs:{"query":_vm.$route.query}})],1),_vm._v(" "),_c('modalModule')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }